exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, "button[data-v-6504f91d] {\n  margin: 2em 0em;\n}\n.birthday-input[data-v-6504f91d] {\n  display: inline-block;\n  margin-right: 0.5em;\n  vertical-align: top;\n}\n.birthday-info[data-v-6504f91d] {\n  padding-top: 1em;\n}\n", ""]);

// exports
